import { CSSObject, ButtonProps } from '@chakra-ui/react';
import { TTableText } from '../../../types';

export const TableItem: CSSObject = {
  borderBottom: '1px dashed',
  // boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.05)',
  borderBottomColor: 'blackAlpha.600',
  borderRight: 'none',
  borderTop: '1px dashed',
  borderTopColor: 'whiteAlpha.200',
  color: 'white',
  pl: 0,
  py: 2,
};

export const TableHeadingsWrapper: CSSObject = {
  'div[class*="desktopTransactionsTable-TableItem"]': {
    borderTop: 'none',
  },
};

export const TableHeadingText: CSSObject = {
  color: 'white',
};

export const TransactionWrapper: CSSObject = {
  h: 'auto',
};

export const TableText = ({ textVariation }: TTableText): CSSObject => ({
  color: textVariation === 'positive' ? 'gamma.300' : 'white',
  fontSize: 'xs',
});

export const NoTransactionsText: CSSObject = {
  color: 'white',
};

export const buttonMoreTableProps: ButtonProps = {
  pt: '1.5',
  fontWeight: 'normal',
};
